export default "/_next/static/chunks/fonts/Muli-Regular-1e6db0b8495f75b8dcc99d690271fd24.ttf";